import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Método para obtener el idioma de los adjuntos.
 *
 * @param {*} param0
 */
export async function getIdioma({commit, state}) {
    if (!state.idiomas.length) {
        commit('dashboard/load', true, {root: true});
        await $http.get('controles/10')
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('cargarIdioma', response.data);
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Metodo para descargar el archivo generado de adjuntos masivos
 *
 * @export
 * @param {*} { commit, state}
 */
export async function descargarAdjuntosMasivo({commit, state}, id) {
    await $http.post(`empresas/procesamientos_background/ADJUNTOS-MASIVO/${id}`)
        .then((response) => {
            commit('setAdjuntosArchivo', response.data.data);
            state.error = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = true;
        });
}


/**
 * Metodo para visualizar los adjuntos agendados del usuario
 *
 * @param {*} { commit}
 */
export async function listarAdjuntosAgendados({commit}, id_empresa) {
    await $http.get(`empresas/procesamientos_background/ADJUNTOS-MASIVO/${id_empresa}`)
        .then((response) => {
            commit('setAdjuntosProcesados', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Método para agendar la descarga masiva de ajuntos.
 *
 * @export
 * @param {*} { commit, state}
 * @param {*} data
 */
export async function agendarAdjuntos({commit, state}, data) {
    const tipo = (data.get('tipoTexto')).split(' ').join('');

    await $http.post(`empresas/procesamientos_background/ADJUNTOS-MASIVO`, data)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 6000
            });
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br >' + error.errors,
                showConfirmButton: false,
                timer: 2000
            });
        });
}


/**
 * Obtener el tipo de adjunto.
 *
 * @param {*} param0
 */
export async function getTipo({commit, state}) {
    if (!state.tipos.length) {
        commit('dashboard/load', true, {root: true});
        await $http.get('controles/14')
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('cargarTipo', response.data);
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Método para obtener el estado de la FDS
 *
 * @param {*} param0
 */
export async function getEstadoFds({commit, state}) {

    if (!state.estados_fds.length) {
        commit('dashboard/load', true, {root: true});
        await $http.get('controles/16')
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('cargarEstadoFds', response.data);
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Método para guardar el adjunto de un producto.
 *
 * @param {*} param0
 * @param {*} data contiene la informacion del producto químico.
 */
export async function guardaAdjunto({commit, state, rootState, dispatch}, data) {
    var producto = rootState.productos.selectedProduct.id;

    if (producto == undefined) {
        producto = rootState.productos.selectedProduct.Idproducto;
    }
    if (state.selectedAdjunto.tipo == 155) {
        state.selectedAdjunto.estado_fds = 163;
    }

    data.append('tipo', state.selectedAdjunto.tipo);
    data.append('fecha', state.selectedAdjunto.fecha);
    data.append('sistema', state.selectedAdjunto.sistema);
    data.append('activo', state.selectedAdjunto.activo);
    data.append('cumple_decreto', state.selectedAdjunto.estado_fds);
    data.append('no_cumple', state.selectedAdjunto.no_cumple);
    data.append('observacion_no_cumple', state.selectedAdjunto.observacion_no_cumple);
    data.append('idioma', state.selectedAdjunto.idioma);
    data.append('observacion', state.selectedAdjunto.observacion);

    commit('dashboard/load', true, {root: true});

    await $http.post(`adm_productos/adjuntos/crear/${producto}`, data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 3000
            });
            commit('limpiarAdjunto');
            await dispatch('getListadoAdj', producto);
            state.error = false;
        })
        .catch(async (error) => {
            const codes = Object.keys(error.errors);
            let errors = [];

            codes.forEach((item) => {
                error.errors[item].forEach((error) => {
                    errors.push(error + "<br>");
                })
            })


            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                html: errors,
                showConfirmButton: true,
                timer: 5000
            });
            // reject(error);
        });
}


/**
 * Método para obtener los adjuntos de un producto químico.
 *
 * @param {*} param0
 */
export async function getListadoAdj({commit, state, rootState}, producto) {
    if (producto !== undefined) {
        commit('dashboard/load', true, {root: true});
        await $http.get(`adm_productos/adjuntos/${producto}`, {params: state.filtro})
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('cargarListadoAdj', response.data);
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

export function setPagePagination({ commit, dispatch, rootState }, page) {
    commit('setPage', parseInt(page));
    dispatch('getAttachmentsByProductId', { productId: rootState.productos.selectedProduct.id, filter: rootState.adjuntos.filter });
}

export function setPerPagePagination({ commit, dispatch, rootState }, perPage) {
    commit('setPerPage', parseInt(perPage));
    dispatch('getAttachmentsByProductId', { productId: rootState.productos.selectedProduct.id, filter: rootState.adjuntos.filter });
}

export function setPagePaginationInactivo({ commit, dispatch, rootState }, pageInact) {
    commit('setPageInactivo', parseInt(pageInact));
    dispatch('getAttachmentsByProductId', { productId: rootState.productos.selectedProduct.id, filter: rootState.adjuntos.filter });
}

export function setPerPagePaginationInactivo({ commit, dispatch, rootState }, perPageInact) {
    commit('setPerPageInactivo', parseInt(perPageInact));
    dispatch('getAttachmentsByProductId', { productId: rootState.productos.selectedProduct.id, filter: rootState.adjuntos.filter });
}

/**
 * Método para editar un adjunto de un producto químico.
 *
 * @param {*} param0
 * @param {*} data contiene la información de un adjunto de un producto químico.
 */
export async function editaAdjunto({commit, state, rootState, dispatch}, data) {


    var producto = rootState.productos.selectedProduct.id;

    if (producto === '') {
        producto = rootState.productos.selectedProduct.Idproducto;
    }

    commit('dashboard/load', true, {root: true});

    await $http.post(`adm_productos/adjuntos/editar/${producto}`, data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 3000
            });
            dispatch('getListadoAdj', producto);
        })
        .catch(async (error) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: true,
                timer: 5000
            });
            reject(error);
        });

}

/**
 * Método para obtener la información de la asignacion de un adjunto.
 *
 * @param {*} param0
 * @param {*} id id del adjunto.
 */
export async function getInfoAsignacion({commit, state, rootState}, id) {

    await $http.get(`adm_productos/asignacion_adjuntos/${id}`)
        .then((response) => {
            commit('cargarAsignaciones', response.data);

            commit('setIdAdjuntoTodos', state.selectedAdjunto.id_adjunto);


            for (let i = 0; i < state.selectedAdjunto.asignaciones.length; i++) {
                if (state.selectedAdjunto.asignaciones[i].asignado == true) {
                    cont++;
                }
            }

            if (cont == state.selectedAdjunto.asignaciones.length) {
                commit('setTodosAsignados', true);

            } else {
                commit('setTodosAsignados', false);
            }

        })
        .catch((error) => {

        });

}

/**
 * Método para guardar la asignacion de un adjunto a una empresa.
 *
 * @param {*} param0
 * @param {*} data contiene toda la información para el proceso.
 */
export async function guardaAsignacion({commit, state, rootState, dispatch}, data, id_producto) {

    let cont = 0;
    var producto = state.selectedAdjunto.id_producto;

    // Se cuenta cuantos adjuntos estan tienen como true el estado de asignado
    for (let i = 0; i < state.selectedAdjunto.asignaciones.length; i++) {
        if (state.selectedAdjunto.asignaciones[i].asignado == true) {
            cont++;
        }
    }

    // Si el contador dio igual a la cantidad de asignaciones significa que todos estan true
    if (cont == state.selectedAdjunto.asignaciones.length) {
        // Se setea como false para luego enviarlo al backend
        commit('setTodosAsignadosObjeto', false);
    } else {
        commit('setTodosAsignadosObjeto', true);
    }


    // Se crea este objeto para enviarlo al backend con los datos necesarios
    let data2 = {
        activo: data.activo,
        asignado: data.asignado,
        id: data.id,
        id_adjunto: data.id_adjunto,
        nombre: data.nombre,
        todo: state.todos.todo
    };


    await $http.post(`adm_productos/asignacion_adjuntos/asignar_empresa/${data.id_adjunto}/${producto}`, data2)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 6000
            });
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para cambiar el estado de un adjunto.
 *
 * @param {*} param0
 * @param {*} id_adjunto id del adjunto.
 */
export async function cambiaEstado({commit, state, rootState, dispatch}, id_adjunto) {

    commit('dashboard/load', true, {root: true});
    await $http.post(`adm_productos/adjuntos/cambiar-estado/${id_adjunto}`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            /* Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 3000
            }) */
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para descargar un adjunto.
 *
 * @param {*} data contiene la informacion del adjunto.
 */
export async function descargarAdjunto({commit, rootState, state}, data) {

    var producto = rootState.productos.selectedProduct.id;

    if (producto == '') {
        producto = rootState.productos.selectedProduct.Idproducto;
    }

    if (producto == undefined) {
        producto = data.id_producto;
    }

    let nombre = '';
    let format_producto = '';
    let format_producto2 = '';
    let tipo = '';

    format_producto = data.producto.replace(' ', '_');
    format_producto2 = format_producto.replace('/', '_');


    switch (data.tipo) {

        case 154:
            tipo = 'FDS';
            break;

        case 155:
            tipo = 'MSDS';
            break;

        case 156:
            tipo = 'ET';
            break;

        case 157:
            tipo = 'TE';
            break;

        case 158:
            tipo = 'AR';
            break;

        case 159:
            tipo = 'Otro';
            break;

        case 177:
            tipo = 'SDS';
            break;

        default:
            // code...
            break;
    }


    nombre = tipo + '_' + format_producto2 + '.' + data.extension;

    commit('dashboard/load', true, {root: true});

    await $http({
        url: 'adm_productos/adjuntos/download/' + producto,
        method: 'POST',
        responseType: 'blob',
        data
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        window.downloadFile(response.data, nombre)
    }).catch((error) => {
        this.$vue.$alertError('No se encontró el archivo');
    }).finally(() => commit('dashboard/load', false, { root: true }));
}


/**
 * Método para obtener los adjuntos de un producto químico.
 *
 * @param {*} commit
 * @param {*} productId: identificador del producto.
 * @param {*} params: parametros para el filtro.
 * @returns
 * @author Fernando Claros
 */
export async function getAttachmentsByProductId({ state, commit }, { productId, filter }) {
    if (!productId) return false;

    commit('dashboard/load', true, { root: true });
    await $http.get(`products/attachments/${productId}`, { params: filter })
        .then(({ data: response }) => {

            commit('cargarListadoAdj', response);
            commit('setAttachments', response.data);

        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Adjuntos del producto',
                text: error.message,
                showConfirmButton: true,
                timer: 5000
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}

/**
 * Método para guardar/actualizar el adjunto de un producto.
 *
 * @param {*} commit
 * @param {*} state
 * @param {*} dispatch
 * @param {*} data: contiene la informacion del producto químico.
 * @param {*} params: parametros para el filtro.
 * @author Fernando Claros
 */
export async function saveAttachment({ commit, state, dispatch }, {data, params}) {
    commit('dashboard/load', true, { root: true });

    const endPoint = data.get('action') === 'CREATE' ? 'products/attachments' : `products/attachments/${data.get('id')}`;

    await $http.post(endPoint, data)
        .then(async ({ data: response }) => {

            commit('setAttachmenteCreated', response.data);
            if (!data.get('customProcess')) {

                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Adjuntos del producto',
                    text: response.message,
                    showConfirmButton: true
                });

                dispatch('getAttachmentsByProductId', { productId: data.get('idProduct'), filter: params });
                commit('limpiarAdjunto');

                state.error = false;

            }
        })
        .catch(async (error) => {

            let errorsText = "";
            try {
                Object.keys(error.errors).forEach(item => {
                    error.errors[item].forEach(error => errorsText += error + "<br>")
                })
            } catch (e) {
                errorsText = "";
            }

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Adjuntos del producto',
                html: "<p>" + error.message + "</p>" + errorsText,
                showConfirmButton: true
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}

/**
 * Cambiar estado del adjunto.
 *
 * @param {*} commit
 * @param {*} dispatch
 * @param {*} idAttachment: identificador del adjunto
 * @param {*} payload: identificador del producto y datos del filtro
 * @author Fernando Claros
 */
export async function changeStatusAttachment({ commit, dispatch }, { id, idProduct, paramsFilter }) {
    commit('dashboard/load', true, { root: true });

    await $http.post(`products/attachments/change-status/${id}`)
        .then(async ({ data: response }) => {

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Adjuntos del producto',
                text: response.message,
                showConfirmButton: true
            });

            dispatch('getAttachmentsByProductId', { productId: idProduct, filter: paramsFilter });

        })
        .catch(error => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Adjuntos del producto',
                text: error.message,
                showConfirmButton: true
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Descargar el archivo del adjunto.
 *
 * @param {*} commit
 * @param {*} id: identificador del adjunto
 * @param {*} nameProduct: nombre del producto
 * @author Fernando Claros
 */
export async function downloadFileAttachment({ commit }, { id, nameProduct } ) {
    commit('dashboard/load', true, { root: true });

    await $http.get(`products/attachments/download-file/${id}`)
        .then(({ data: response, status }) => {

            if (status !== 200) return false;

            try {

                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Adjuntos del producto',
                    text: response.message,
                    showConfirmButton: true
                });

                let linkTemporary = document.createElement("a");
                document.body.appendChild(linkTemporary);

                linkTemporary.setAttribute("type", "hidden");
                linkTemporary.href = `data:text/plain;base64,${response.data.file}`;
                linkTemporary.download = `${nameProduct}-adjunto-${id}.${response.data.extension}`;
                linkTemporary.click();

                document.body.removeChild(linkTemporary);

            } catch (e) {
                Swal.fire({
                    position: 'center',
                    icon: 'info',
                    title: 'Adjuntos del producto',
                    text: response.message,
                    showConfirmButton: true
                });
            }

        })
        .catch(error => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Adjuntos del producto',
                text: error.message,
                showConfirmButton: true
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Cargar las empresas disponibles con estado de asignación al adjunto.
 *
 * @param {*} commit
 * @param {*} idAttachment: identificador del adjunto
 * @author Fernando Claros
 */
export async function getCompaniesAvailableTobeAssigned({ state, commit }, idAttachment) {
    commit('dashboard/load', true, { root: true });

    await $http.get(`products/attachments/companies-available/to-be-assigned/${idAttachment}`)
        .then(({ data: response }) => {

            let quantity = 0;
            response.data.map(x => {
                if (x.asignado == true) quantity += 1;
            })

            commit('setTodosAsignados', (quantity == response.data.length) ? true : false);
            commit('cargarAsignaciones', { asignaciones: response.data });
            commit('setIdAdjuntoTodos', idAttachment);

        })
        .catch(error => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Adjuntos del producto',
                text: error.message,
                showConfirmButton: true
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Asignar empresas a un adjunto.
 *
 * @param {*} commit
 * @param {*} id: identificador del adjunto
 * @param {*} company: estado de la accion (0: inactivar / 1: activar)
 * @author Fernando Claros
 */
export async function assignCompanies({ commit, dispatch }, { id, company, action }) {
    commit('dashboard/load', true, { root: true });

    await $http.post(`products/attachments/assign-companies/${id}`, {
            action, company
        })
        .then(({ data: response }) => {

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Adjuntos del producto',
                text: response.message,
                showConfirmButton: true
            });

            dispatch('getCompaniesAvailableTobeAssigned', id);

        })
        .catch(error => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Adjuntos del producto',
                text: error.message,
                showConfirmButton: true
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}


/**
 * Listar total de TE generados y adjuntos
 * @param payload: company_id, slq_location_id, type
 * @autor Paul Valencia
 */
export async function getTotalAttachmentsTECompany({commit}, company_id) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`products/te-attachments-generate`, {params: {company_id}});
        commit('setTotalTE', response.data.data);
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Obtener adjuntos fds msds con fecha más reciente de un producto químico.
 *
 * @param {*} commit
 * @param {*} productId: identificador del producto.
 * @author Paul Valencia.
 */
export async function getAttachmentsFdsMsdsByProductId({state, commit }, productId) {
    if (!productId) return false;
    commit('dashboard/load', true, { root: true });
    await $http.get(`products/attachments-fsd-msds/${productId}`,
        {
            params: {
                all: state.filtro.all
            }
        }
    )
        .then(({ data: response }) => {
            commit('setAttachmentsFdsMsds', response.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Adjuntos del producto',
                text: error.message,
                showConfirmButton: true,
                timer: 5000
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}



/**
 * Agregar adjunto a componentes
 *
 * @param {*} commit
 * @param {*} payload
 */
export async function addAttachmentstoComponents({ commit }, payload) {
    commit('dashboard/load', true, { root: true });
    await $http.post(`products/attachments/historical_revisions`,payload)
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Adjuntos del producto',
                text: error.message,
                showConfirmButton: true,
                timer: 5000
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}


/**
 * Agregar adjunto a componentes
 *
 * @param {*} commit
 * @param {*} payload
 */
export async function saveAttachmentHistoricalRevisions({ state,commit, dispatch }, payload) {
    commit('dashboard/load', true, { root: true });
    await $http.post(`products/attachments-fds/historical_revisions`,payload)
        .then(({ data: response }) => {
            this.$vue.$alertSuccess(response.message);
            state.filterHistRev.prod_attachment_id = payload.get('prod_attachment_id');
            dispatch('getAttachmentHistoricalRevisions',state.filterHistRev)
        })
        .catch((error) => {
            if (this.$vue.$alertErrorsCallback(error)) return;
            this.$vue.$alertError(error.message);
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}

export async function getAttachmentHistoricalRevisions({ commit }, filter) {
    commit('dashboard/load', true, { root: true });
    await $http.get(`products/attachments-fds/historical_revisions`, {params: {...filter}})
        .then(({ data: response }) => {
            commit('setHistoricalRevisionAttach', response.data);
        })
        .catch((error) => {
            if (this.$vue.$alertErrorsCallback(error)) return;
            this.$vue.$alertError(error.message);
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}


/**
 * Eliminar registro y archivo.
 *
 * @param id
 * @autor Paul Valencia
 * @returns void
 */
export async function deleteHistoricalRevisions({state,dispatch}, item) {
    await $http.patch(`products/attachments-fds/historical_revisions/${item.id}/delete`).then(async (response) => {
        this.$vue.$alertSuccess(response.data.message);
        state.filterHistRev.prod_attachment_id = item.prod_attachment_id;
        dispatch('getAttachmentHistoricalRevisions',state.filterHistRev)
    }).catch(async (error) => {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    });
}

/**
 * Actualizar registro.
 *
 * @param id
 * @autor Paul Valencia
 * @returns void
 */
export async function updateHistoricalRevisionFds({state, dispatch}, item) {
    await $http.post(`products/attachments-fds/historical_revisions/${item.get('id')}/update`,item).then(async (response) => {
        this.$vue.$alertSuccess(response.data.message);
        state.filterHistRev.prod_attachment_id = item.get('prod_attachment_id');
        dispatch('getAttachmentHistoricalRevisions',state.filterHistRev)
    }).catch(async (error) => {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    });
}
